import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TableContext, TableHeaderContext, TableBodyContext, TableFooterContext, TableRowContext } from "./TableContext.mjs";
import { row } from "./Table.css.mjs";
const TableRow = ({ children, data, ...restProps }) => {
  const tableContext = useContext(TableContext);
  const tableHeaderContext = useContext(TableHeaderContext);
  const tableBodyContext = useContext(TableBodyContext);
  const tableFooterContext = useContext(TableFooterContext);
  const tableRowContext = useContext(TableRowContext);
  assert(tableContext, "TableRow must be used within a Table component");
  assert(
    !tableRowContext,
    "TableRow cannot be nested instead another TableRow"
  );
  assert(
    tableBodyContext || tableHeaderContext || tableFooterContext,
    "TableRow must be used within a table section, e.g. TableHeader, TableBody or TableFooter component"
  );
  return /* @__PURE__ */ jsx(TableRowContext.Provider, { value: true, children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "tr",
      className: row,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  ) });
};
export {
  TableRow
};
